"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _utils = require("../utils/utils");

var normalizeTheme = function normalizeTheme(_ref) {
  var props = _ref.props,
      keywords = _ref.keywords,
      breakpoints = _ref.breakpoints;
  var theme = (0, _utils.calculateTheme)({
    props: props,
    keywords: keywords,
    breakpoints: breakpoints
  });
  var result = {};
  Object.keys(theme).forEach(function (item) {
    var itemValue = theme[item];
    breakpoints.forEach(function (bp, i) {
      if (Number.isFinite(itemValue[bp]) && itemValue[bp] !== itemValue[breakpoints[i - 1]]) {
        (0, _lodash.set)(result, [item, bp], itemValue[bp]);
      }
    });
  });
  return result;
};

var _default = normalizeTheme;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/coolgrid/dist/Row/utils.js
// module id = 236
// module chunks = 0